<template>
<m-pageframe
    :title="title"
>
<v-container
    v-if="settings != null"
>
    <div
        v-if="settings.is_connected_to_red_chirp_email"
        style="background-color: rgba(255,0,0,0.2); padding: 15px; margin-bottom: 15px; border: 2px solid black;"
    >
        <p>
            <b>WARNING</b>:  This typeform is still set to send submissions to RedChirp via email.<br/><br/>If you connect this typeform to an inbox and still have the form connected to email you will wind up with double contact requests.
        </p>

        <v-btn
            v-on:click="onClickRefresh"
        >
            Refresh
        </v-btn>
    </div>

    <v-text-field
        label="Title"
        :value="settings.title"
        disabled
        readonly
        autocomplete="off"
    />

    <v-text-field
        label="Form Id"
        :value="settings.form_id"
        disabled
        readonly
        autocomplete="off"
    />

    <v-btn
        color="primary"
        v-on:click="onClickViewForm"
        style="margin-right: 15px"
    >
        View
    </v-btn>

    <v-btn
        v-on:click="onClickEditForm"
    >
        Edit
    </v-btn>

    
    
    
    <br/><br/>


    <v-text-field
        label="Webhook Set"
        :value="settings.webhook_set"
        disabled
        readonly
        autocomplete="off"
    />

    <m-autocomplete-organization
        label="Connect to Organization"
        v-model="settings.organization_id"
        v-on:input="upsertSettings"
    />

    <v-select
        label="Inbox"
        v-model="settings.inbox_id"
        :items="settings.inbox_choices"
        v-on:change="upsertSettings"
    />

    <p><b>Consent</b></p>
    <p>If <b>all</b> legal questions are answered "I accept" then the respondant has consented to receive messages in the following categories:</p>
    
    <v-checkbox
        label="Conversational"
        v-model="settings.grant_conversational"
        v-on:change="upsertSettings"
        style="margin-bottom: -25px;"
    />

    <v-checkbox
        label="Informational"
        v-model="settings.grant_informational"
        v-on:change="upsertSettings"
        style="margin-bottom: -25px;"
    />

    <v-checkbox
        label="Promotional"
        v-model="settings.grant_promotional"
        v-on:change="upsertSettings"
        style="margin-bottom: -25px;"
    />


</v-container>
</m-pageframe>
</template>

<script>
export default {
    
    data() {
        return {
            settings: null,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        doUpdate() {
            
            this.$rc.rest(
                'GET: /api/v1/integrations/typeform/settings/:form_id',
            
                {
                    'form_id' : this.$route.params.form_id,
                },
            
                (data) => {

                    this.settings = data;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to get form');
                },
            );
        },

        upsertSettings() {
           
            this.$rc.rest(
                'PUT: /api/v1/integrations/typeform/settings',
            
                this.settings,
            
                (data) => {
                    this.settings = data;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to save settings.');
                },
            );
        },

        onSetOrganization(org_id)
        {
            alert(org_id);
        },

        onClickViewForm()
        {
            window.open(this.settings.display_url);
        },

        onClickEditForm()
        {
            window.open(this.settings.edit_url);
        },

        onClickRefresh()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET: /api/v1/integrations/typeform/refresh-email-connect/:form_id',
            
                {
                    'form_id' : this.settings.form_id,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.settings = data;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to refresh form meta data');
                },
            );
            
        },
    },    

    computed: {
        title() {
            if ( this.settings == null )
                return 'Typeform Settings';
            
            return 'Typeform Settings: '+this.settings.title;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>